import { ControlledInput, ControlledSelectRoot, ControlledTextArea } from "shared/components";
import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { UpdateProfileFormValues } from "apps/directory/Operator/views";
import { pricingOptions } from "shared/constants";
import { Select } from "@ttc3k/trekker";

export const KeyInfo = () => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<UpdateProfileFormValues>();
  const pricing = useWatch({ control, name: "pricing" });
  const handleSelectPricing = (pricing: string) => {
    setValue("pricing", pricing, { shouldDirty: true });
  };

  return (
    <Flex flexDir={"column"} gap={"200"}>
      <ControlledInput
        name={"businessName"}
        label={t(
          "directory:OPERATOR.ADD_OPERATOR_MODAL.BUSINESS_INFO.BUSINESS_NAME",
        )}
      />
      <ControlledTextArea
        name={"longDescription"}
        label={t("directory:OPERATOR.PROFILE.KEY_INFO.LONG_DESCRIPTION")}
      />
      <ControlledTextArea
        name={"shortDescription"}
        label={t("directory:OPERATOR.PROFILE.KEY_INFO.SHORT_DESCRIPTION")}
        rows={3}
      />
      <ControlledSelectRoot
        name={"pricing"}
        items={pricingOptions}
        value={[pricing ?? ""]}
        label={t("directory:OPERATOR.PROFILE.KEY_INFO.PRICING")}
        onValueChange={({ value }: { value: string[] }) =>
          handleSelectPricing(value[0])
        }
      >
        {pricingOptions.map((pricingOpt) => (
          <Select.Item key={pricingOpt.value} item={pricingOpt} />
        ))}
      </ControlledSelectRoot>
    </Flex>
  );
};
